var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topbar"},[(
      _vm.currentUser !== null &&
      _vm.currentUser.email &&
      this.$router.currentRoute.name === 'home'
    )?_c('div',{staticClass:"btn btn-primary btn-rounded px-7 py-3 ml-4 text-uppercase",on:{"click":function($event){return _vm.$router.push('/dashboard')}}},[_c('h6',{staticClass:"m-0 p-0"},[_vm._v("Dashboard")])]):_vm._e(),(_vm.currentUser !== null && _vm.currentUser.email)?_c('KTQuickUser',{staticClass:"ml-4"}):_c('div',{staticClass:"btn btn-primary btn-rounded px-7 py-3 ml-4 text-uppercase",on:{"click":function($event){return _vm.$router.push('/login')}}},[_c('h6',{staticClass:"m-0 p-0"},[_vm._v("Login")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }